import createComponent from '../create-component';
export default createComponent([["title",{"key":"svg-title"}],["rect",{"width":"1000","height":"1000","fill":"#855dcd","rx":"200","key":"svg-rect"}],["g",{"fill":"#fff","key":"svg-g"}]]);